import { css } from 'styled-components';
import { WelcomeViewProps } from './models';

const stickyWrapperHeight = 80;

export const WelcomeView = css<WelcomeViewProps>(({ theme }) => {
  return css`
    &.view-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0px 20px;
      gap: 32px;

      > .legal {
        text-align: left;
      }

      > .legal-section {
        align-self: flex-start;

        > .disclaimer-note {
          padding-top: 24px;
        }
      }

      > .how-it-works {
        @media screen and ${theme.device.mobileXL} {
          width: 633px;
        }
      }

      @media screen and ${theme.device.mobileXL} {
        width: 800px;
        margin: 0 auto;
      }
    }

    &.button-container {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;

      > .scroll-notice {
        background: ${theme.colors.primaryDeepBlue};
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;
        padding: 8px 16px;
      }

      > .sticky-button-wrapper {
        padding: 10px;
        background-color: white;
        height: ${stickyWrapperHeight}px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0px -6px 8px -4px rgba(24, 39, 75, 0.04);

        > .submit-button,
        > .submit-button-container > .submit-button {
          width: 252px;
          margin: 0;
        }

        > .submit-button-container {
          position: relative;
          width: 100%;
          display: flex;
          justify-content: center;

          > .overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: transparent;
          }
        }
      }
    }

    &.button-placeholder {
      padding-top: ${stickyWrapperHeight}px;
    }
  `;
});
